import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/navbar/Header";
import Footer from "../../components/footer/Footer";

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | Gem Maruti</title>
        <meta
          name="description"
          content="Privacy Policy for Gem Maruti – Learn how we collect, use, and protect your personal information."
        />
      </Helmet>

      <Header />

      <div className="bg-gray-100 py-10">
        <div className="container mx-auto px-5 sm:px-10 lg:px-20">

          <h1 className="text-3xl font-bold text-center text-gray-800">
            Privacy Policy
          </h1>
          <div className="w-24 h-1 bg-red-600 mx-auto my-3 rounded"></div>

          <p className="text-center text-sm text-gray-500 mb-10">
            Last Updated: January 2025
          </p>

          <div className="bg-white p-6 sm:p-10 rounded-lg shadow-md space-y-6 text-gray-700 leading-relaxed">

            {/* INTRO */}
            <p>
              Welcome to <strong>Gem Maruti</strong> ("we", "our", "us"). We are committed
              to protecting your personal information and your right to privacy. This
              Privacy Policy explains how we collect, use, and safeguard your data when
              you visit our website <strong>https://gemmaruti.com/</strong>.
            </p>

            {/* SECTION 1 */}
            <h2 className="text-xl font-semibold text-gray-800">1. Information We Collect</h2>
            <p>We may collect the following information when you use our website:</p>

            <ul className="list-disc ml-6 space-y-1">
              <li><strong>Personal Information:</strong> Name, phone, email, model preference, city.</li>
              <li><strong>Automatically Collected:</strong> IP address, browser, device data, pages visited.</li>
              <li><strong>Third-party Data:</strong> Google Analytics, Facebook Pixel, CRM systems.</li>
            </ul>

            {/* SECTION 2 */}
            <h2 className="text-xl font-semibold text-gray-800">2. How We Use Your Information</h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>Process inquiries and contact requests</li>
              <li>Provide test drive & sales assistance</li>
              <li>Send on-road prices, offers, and updates</li>
              <li>Improve website experience</li>
              <li>Marketing & remarketing (Google/Facebook)</li>
            </ul>

            {/* SECTION 3 */}
            <h2 className="text-xl font-semibold text-gray-800">3. Sharing of Information</h2>
            <p>We do not sell your personal information. We may share your data with:</p>
            <ul className="list-disc ml-6 space-y-1">
              <li>Maruti Suzuki dealership teams</li>
              <li>CRM & lead management tools</li>
              <li>Analytics services like Google Analytics</li>
              <li>SMS/Email service providers</li>
            </ul>

            {/* SECTION 4 */}
            <h2 className="text-xl font-semibold text-gray-800">4. Cookies & Tracking</h2>
            <p>
              We use cookies to enhance user experience and for analytics, advertising,
              and website performance improvement. You may disable cookies in your
              browser settings.
            </p>

            {/* SECTION 5 */}
            <h2 className="text-xl font-semibold text-gray-800">5. Data Security</h2>
            <p>
              We take industry-standard steps such as encryption, secure hosting, and
              restricted access. However, no system is 100% secure.
            </p>

            {/* SECTION 6 */}
            <h2 className="text-xl font-semibold text-gray-800">6. Your Rights</h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>Request deletion of your data</li>
              <li>Request access or correction</li>
              <li>Withdraw consent anytime</li>
              <li>Opt-out of marketing communication</li>
            </ul>

            {/* SECTION 7 */}
            <h2 className="text-xl font-semibold text-gray-800">7. Third-Party Links</h2>
            <p>
              Our website may contain external links. We are not responsible for the
              privacy practices of third-party sites.
            </p>

            {/* SECTION 8 */}
            <h2 className="text-xl font-semibold text-gray-800">8. Children’s Privacy</h2>
            <p>
              We do not knowingly collect information from children under the age of 16.
            </p>

            {/* SECTION 9 */}
            <h2 className="text-xl font-semibold text-gray-800">9. Updates to This Policy</h2>
            <p>
              We may update this Privacy Policy periodically. Updated versions will be
              posted here with a revised date.
            </p>

            {/* SECTION 10 */}
            <h2 className="text-xl font-semibold text-gray-800">10. Contact Us</h2>
            <p>
              For any questions or requests regarding privacy, please contact us:
            </p>

            <p><strong>Gem Motors Private Limited</strong></p>
            <p>Hyderabad, Telangana</p>
            <p>Email: <a href="mailto:info@gemmaruti.com" className="text-red-600 underline">info@gemmaruti.com</a></p>
            <p>Website: <a href="https://gemmaruti.com" className="text-red-600 underline">https://gemmaruti.com</a></p>

          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;
